import React from 'react';
import {Slide ,Bounce } from 'react-awesome-reveal'
import AZ from '../../assets/logos/azb.png'




const MainContainerAdhesion2 = () => {
  return (
    <section id="main-container" className="main-container" 
    style={{
      backgroundImage: 'url(images/assets/ban5.jpg)',
        
      }}
    >
      <div className="container">
      <div className="text-center mb-3">
                      <Bounce>
                        <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 400 }} />
                      </Bounce>
                    
                    </div>
        <div className="row">
          {/* Colonne gauche */}
          <div className="col-lg-12">
          <Slide direction="down">
            <h1 className="column-title display-5 fw-bold" style={{fontFamily:'Times',color:'#000'}}><b>
            NOUS VOUS GARANTISSONS :
            <hr />
                 </b></h1>
            </Slide>
            <Slide direction="up">
            <b className="column-title fs-4  fw-bold" style={{fontFamily:'Times',color:'#000'}}>
            ◼︎ Des tarifs préférentiels exclusifs. <br />
            ◼︎ Des privilèges exceptionnels. <br />
            ◼︎ Un traitement immédiat de vos demandes. <br />
            ◼︎ La prise en charge d’éventuels imprévus. <br />
            ◼︎ Des solutions où que vous soyez dans le monde.
            </b>
            </Slide>
         
            
          </div>
         
        
       

          {/* Colonne droite */}
        
        </div> {/* Row end */}
      </div> {/* Container end */}
    </section>
  );
};

export default MainContainerAdhesion2;
